import React, { MutableRefObject, useReducer, useState } from 'react';
import { Content } from 'src/common/interfaces/content.interface';
import { MediaIntegrationsPanel } from './integrations-panel';

import {
  IntegrationValue,
  JourneyTabValue,
  GongTabValue,
  GoogleDriveTabValue,
  MicrosoftOneDriveTabValue,
  BoxTabValue,
  DropboxTabValue,
} from './types';
import { IntegrationGongPanel } from './gong-panel';
import { IntegrationGoogleDrivePanel } from './google-drive-panel';
import { JourneyMediaPanel } from './journey-media-panel';
import { IntegrationMicrosoftOneDrivePanel } from './microsoft-one-drive-panel';
import { IntegrationDropboxPanel } from './dropbox-panel';
import { IntegrationBoxPanel } from './box-panel';

type Props = {
  onSelectContent: (content: Content) => void;
  onControlPanelDragEndRef: MutableRefObject<() => void>;
  onNewUrl: (url: string, title: string, isBoxLink?: boolean) => void;
  onNewVideo: (url: string, metaData: any, importParams: any) => void;
  setBlockToLoading: () => void;
};

export const AddMediaControlPanelContent = ({
  onSelectContent,
  onControlPanelDragEndRef,
  onNewUrl,
  onNewVideo,
  setBlockToLoading,
}: Props) => {
  const [updateKey, forceUpdate] = useReducer((x) => x + 1, 0);
  const [activeTabValue, setActiveTabValue] = useState<IntegrationValue>(JourneyTabValue);

  onControlPanelDragEndRef.current = () => {
    forceUpdate();
  };

  return (
    <div className='flex flex-col gap-4 neue-scrollbar'>
      <MediaIntegrationsPanel activeTabValue={activeTabValue} onTabValueChange={(value) => setActiveTabValue(value)} />
      {activeTabValue === JourneyTabValue && (
        <JourneyMediaPanel onSelectContent={onSelectContent} updateKey={updateKey} />
      )}
      {activeTabValue === GongTabValue && (
        <div className='h-[478px] overflow-y-auto flex items-start'>
          <IntegrationGongPanel onNewVideo={onNewVideo} />
        </div>
      )}
      {activeTabValue === GoogleDriveTabValue && (
        <div className='h-[478px] overflow-y-auto flex items-start'>
          <IntegrationGoogleDrivePanel onNewUrl={onNewUrl} />
        </div>
      )}
      {activeTabValue === BoxTabValue && (
        <div className='h-[478px] overflow-y-auto flex items-start'>
          <IntegrationBoxPanel
            onNewUrl={(...args) => {
              onNewUrl(...args, true);
            }}
          />
        </div>
      )}
      {activeTabValue === DropboxTabValue && (
        <div className='h-[478px] overflow-y-auto flex items-start'>
          <IntegrationDropboxPanel onNewUrl={onNewUrl} setBlockToLoading={setBlockToLoading} />
        </div>
      )}
      {activeTabValue === MicrosoftOneDriveTabValue && (
        <div className='h-[478px] overflow-y-auto flex items-start'>
          <IntegrationMicrosoftOneDrivePanel onNewUrl={onNewUrl} />
        </div>
      )}
    </div>
  );
};
